import styled from 'styled-components';

export const Caption = styled.div`
	display: flex;
	align-items: center;
	font-size: x-small;
	margin-bottom: 5px;
	color: rgba(0, 0, 45, 0.6);
	gap: 5px;

	.MuiSvgIcon-root {
		color: rgba(0, 0, 45, 0.4) !important;
		width: 0.6em;
		height: 0.6em;
	}
`;

export const Body = styled.div`
	font-weight: normal;
`;
